import { render, staticRenderFns } from "./login.vue?vue&type=template&id=f65408b4&scoped=true"
import script from "./login.vue?vue&type=script&lang=js"
export * from "./login.vue?vue&type=script&lang=js"
import style0 from "./login.vue?vue&type=style&index=0&id=f65408b4&prod&lang=scss"
import style1 from "./login.vue?vue&type=style&index=1&id=f65408b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f65408b4",
  null
  
)

export default component.exports